import firebase from "firebase";
import {MD5} from "crypto-js"
import {formatPrice} from "./formatHelper";
import DocumentSnapshot = firebase.firestore.DocumentSnapshot;
import { SessionMenuItem } from "../models/session";
import { MenuItemAddOn, MenuItemOption } from "../models";
import { Minus } from "../models/menuItem";

const evaluateDitsMenuItemPrice = (ditsMenuItem: DocumentSnapshot, qty: number = 1) => {
    const defaultPrice = ditsMenuItem?.data()?.price;
    const addOnsPrice = evaluateAddOnsPrice(ditsMenuItem?.data()?.add_ons ?? [])
    return (defaultPrice + addOnsPrice) * qty;
}

const evaluateDitsMenuItemPriceV2 = (ditsMenuItem: SessionMenuItem, qty: number = 1) => {
    const defaultPrice = ditsMenuItem?.price;
    const addOnsPrice = evaluateAddOnsPriceV2(ditsMenuItem?.add_ons ?? [])
    return (defaultPrice + addOnsPrice) * qty;
}

const evaluateAddOnsPriceV2 = (addOns: MenuItemAddOn[]) => {
    return (addOns ?? []).reduce((acc: number, addOn: MenuItemAddOn) => {
        const addOnPrice = (addOn?.options ?? []).reduce((price: number, option: MenuItemOption) => price += option.price ?? 0, 0)
        return acc += addOnPrice;
    }, 0);
}

const evaluateAddOnsPrice = (addOns: any[]) => {
    return (addOns ?? []).reduce((acc: number, addOn: any) => {
        const addOnPrice = (addOn?.options ?? []).reduce((price: number, option: any) => price += option.price ?? 0, 0)
        return acc += addOnPrice;
    }, 0);
}

const formatDitsMenuItemPrice = (ditsMenuItem: DocumentSnapshot|null, qty: number = 1) => {
    if (!!ditsMenuItem) {
        return formatPrice(evaluateDitsMenuItemPrice(ditsMenuItem, qty));
    }
    return formatPrice(0);
}

const formatDitsMenuItemPriceV2 = (ditsMenuItem: SessionMenuItem, qty: number = 1) => {
    return formatPrice(evaluateDitsMenuItemPriceV2(ditsMenuItem, qty));
}

export interface GroupItems {
    [key: string]: {
        item: SessionMenuItem,
        items: SessionMenuItem[],
        key: string,
        order: string,
        qty: number,
    }
}

export interface GroupItem {
    item: SessionMenuItem,
    items: SessionMenuItem[],
    key: string,
    order: string,
    qty: number,
}

const groupSameItems = (ditsMenuItems: SessionMenuItem[]) => {
    const mapGroupedItems: GroupItems = {};
    for (const index in ditsMenuItems) {
        const item = ditsMenuItems[index];
        const addOnsResult = (item.add_ons).map((e: MenuItemAddOn) => (e.options).map((item: MenuItemOption) => item?.id ?? '').join(',')).join(',');
        const minusResult = (item.minus).map((e:Minus) => e.id ?? "").join(',');
        let key = item.name
            + (item.sales_model != null ? item.sales_model : '')
            + item.sale_comment
            + item.price;
            key += (item?.menu_item?? '')
                + item?.course
                + addOnsResult
                + minusResult
                + (item.note ?? '');
        const hashedKey = MD5(key).toString();
        if (!!mapGroupedItems && !!mapGroupedItems[hashedKey]) {
            mapGroupedItems[hashedKey].qty += 1;
            mapGroupedItems[hashedKey].items.push(item)
        } else {
            mapGroupedItems[hashedKey] = {
                item,
                key: hashedKey,
                items: [item],
                qty: 1,
                order: index
            };
        }
    }
    const groupedItems = Object.values(mapGroupedItems).sort((a: any, b: any) => a['order'] - b['order']);
    return groupedItems;
}

const onDeleteItems = (groupedItems: any[], key: string, deleteFunction: (items: DocumentSnapshot[]) => any) => {
    const groupItem = groupedItems.find((item: any) => item.key === key);
    if (!!groupItem && !!groupItem.items && groupItem.items.length > 0) {
        if (!!deleteFunction) {
            deleteFunction([groupItem.items[groupItem.items.length - 1]]);
        }
    }
}

export {
    evaluateDitsMenuItemPrice,
    evaluateDitsMenuItemPriceV2,
    evaluateAddOnsPrice,
    formatDitsMenuItemPrice,
    formatDitsMenuItemPriceV2,
    groupSameItems,
    onDeleteItems
}
